import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="home-container">
        <div className="hero-section">
          <h1 className="hero-title">Buz Pateni Eğitmeni</h1>
          <div className="hero-content">
            <div className="profile-image">
              <div className="image-placeholder">
                ⛸️
              </div>
            </div>
            <div className="intro-text">
              <p className="intro-paragraph">
                Buz pateninde kalıcı gelişimin doğru teknik, güven ve bireysel yaklaşım ile mümkün olduğuna inanıyoruz. 
                Sektörde 7 yılı aşkın süredir, buz patenine yeni başlayanlardan ileri seviyeye kadar her düzeyden sporcu ile çalışıyoruz.
              </p>
              <p className="intro-paragraph">
                Her sporcunun yaşı, fiziksel yapısı, öğrenme hızı ve hedefleri farklıdır. 
                Bu nedenle eğitim sürecimizi tek tip programlarla değil, sporcunun bireysel ihtiyaçlarını merkeze alan bir anlayışla planlıyoruz.
              </p>
              <p className="intro-paragraph">
                Bizim için dersler yalnızca teknik öğretim değildir. 
                Süreç boyunca sporcuların denge, disiplin, özgüven ve spor kültürü kazanmasını önemsiyoruz. 
                Gelişimini ilerletmek isteyen sporcular için ise süreci daha planlı, sistemli ve hedef odaklı bir yapıya dönüştürüyoruz.
              </p>
            </div>
          </div>
        </div>

        {/* Hakkımızda Section */}
        <div className="content-section section-about">
          <div className="section-header">
            <h2 className="section-title">Hakkımızda</h2>
          </div>
          <div className="section-content">
            <p className="content-paragraph">
              Buz pateninde kalıcı gelişimin doğru teknik, güven ve bireysel yaklaşım ile mümkün olduğuna inanıyoruz. 
              Sektörde 7 yılı aşkın süredir, buz patenine yeni başlayanlardan ileri seviyeye kadar her düzeyden sporcu ile çalışıyoruz.
            </p>
            <p className="content-paragraph">
              Her sporcunun yaşı, fiziksel yapısı, öğrenme hızı ve hedefleri farklıdır. 
              Bu nedenle eğitim sürecimizi tek tip programlarla değil, sporcunun bireysel ihtiyaçlarını merkeze alan bir anlayışla planlıyoruz.
            </p>
            <p className="content-paragraph">
              Bizim için dersler yalnızca teknik öğretim değildir. 
              Süreç boyunca sporcuların denge, disiplin, özgüven ve spor kültürü kazanmasını önemsiyoruz. 
              Gelişimini ilerletmek isteyen sporcular için ise süreci daha planlı, sistemli ve hedef odaklı bir yapıya dönüştürüyoruz.
            </p>
          </div>
        </div>

        {/* Eğitim Yaklaşımımız Section */}
        <div className="content-section section-approach">
          <div className="section-header">
            <h2 className="section-title">Eğitim Yaklaşımımız</h2>
          </div>
          <div className="section-content">
            <p className="content-paragraph">
              Eğitim yaklaşımımızın temelinde güvenlik, doğru temel ve sürdürülebilir gelişim yer alır. 
              Buz pateninde hızlı değil, doğru ilerlemenin kalıcı başarı getirdiğine inanıyoruz.
            </p>
            
            <h3 className="subsection-title">Yeni Başlayanlar İçin Eğitim Süreci</h3>
            <p className="content-paragraph">
              Yeni başlayanlar için eğitim süreci:
            </p>
            <ul className="content-list">
              <li>Korkuyu azaltan</li>
              <li>Adım adım ilerleyen</li>
              <li>Sporcunun kendini güvende hissettiği</li>
            </ul>
            <p className="content-paragraph">
              bir yapıdadır.
            </p>
            
            <p className="content-paragraph">
              Temel seviyede doğru duruş, denge ve kontrol becerilerine odaklanılır.  
              İlerleyen aşamalarda teknik gelişim sistemli şekilde desteklenir.
            </p>
            
            <p className="content-paragraph">
              Dersler bireyselleştirilmiş öğretim anlayışıyla yürütülür.
            </p>
            
            <h3 className="subsection-title">Başarı Kriterimiz</h3>
            <p className="content-paragraph">
              Başarı kriterimiz:
            </p>
            <ul className="content-list">
              <li>Güven kazanımı</li>
              <li>Süreci sevme</li>
              <li>Uzun vadeli gelişim</li>
            </ul>
            <p className="content-paragraph">
              olarak tanımlanır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

